import { LoadingSpinner, Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';
import { HomeBookmark } from './HomeBookmark';
import { BookmarksList } from './BookmarksList';
import { useGetBookmarks } from '@ais-ui/websockets';
import React, { useMemo } from 'react';
import { NoItemsEmptyStateList } from '../../../components/EmptyList';
import { BookmarksAddEdit } from './BookmarksAddEdit';

export function SettingsBookmarksPage() {
  const { messages } = useLocalization();

  const { data, isLoading, isError } = useGetBookmarks();
  const bookmarks = useMemo(() => {
    if (data) {
      return data;
    }
    return [];
  }, [data]);

  return (
    <div className="space-y-6 w-full">
      {isLoading && <LoadingSpinner></LoadingSpinner>}
      {isError && <div>ERROR</div>}
      {!isLoading && bookmarks.length === 0 && (
        <NoItemsEmptyStateList entity="bookmark" srcImage="empty_list_bro.png">
          <BookmarksAddEdit
            mode={'create'}
            className={'w-[80%] h-10'}
          ></BookmarksAddEdit>
        </NoItemsEmptyStateList>
      )}
      {!isLoading && bookmarks.length > 0 && (
        <div className="w-full space-y-4">
          <HomeBookmark bookmarks={bookmarks}></HomeBookmark>
          <div className="pt-4">
            <h3 className="text-lg font-medium">
              {messages.settingsBookmarksListTitle}
            </h3>
          </div>
          <BookmarksList bookmarks={bookmarks} />
        </div>
      )}
    </div>
  );
}
